export default {
  Name: "",
  CustomerCode: "",
  ContactDocument: "",
  ContactName: "",
  Amount: 0,
  Probability: 0,
  CurrencyID: undefined,
  ResponsibleID: undefined,
  InitialDate: "",
  FinalDate: "",
  DeliveryDate: "",
  ServicesAmount: 0,
  DealsTypeID: undefined,
  Comment: "",
  EstatusID: null,
  Estatus: null,
  Reason: "",
  ContractTimeID: undefined,
  PhaseID: undefined,
  Quantity: undefined,
  UnitPrice: undefined,
  IsLosed: false,
  IsWinned: false,
  CompanyID: "",
  GetSubTotals: 0,
  DealsLogs: null,
  Comments: null,
  CreatedBy: 0,
  CreatedAt: "",
  UpdatedBy: 0,
  LastUpdatedAt: "",
  Id: 0,
  IsEnabled: false,
  IsNull: false
};
